const ProdConfig = {
  apiBaseUrl: 'https://api.disputealert.com',
  apiBpBaseUrl: 'https://bp.disputealert.com',
};

export default ProdConfig;
